import React, { useState, useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';
import styledComponents from 'styled-components';
import classnames from 'classnames';
import { useDebouncedCallback } from 'use-debounce';

import CaretIcon from '@icons/CaretIcon';
import colors from '@general/colors';
import fonts from '@general/fonts';

const ButtonStyled = styledComponents.button`
    color: ${colors.primary};
    font-family: ${fonts.sans};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.94px;
    line-height: 22px;
    background-color: transparent;
    padding: 0;
    margin-top: 10px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
`;

const hasClamping = el => {
    const { clientHeight, scrollHeight } = el;
    return clientHeight !== scrollHeight;
};

// adapted from https://javascript.plainenglish.io/creating-a-read-more-collapsible-component-in-reactjs-6d55fbc4ff0f
// if you pass in something other than 4, you will have to add a class
const ReadMore = ({ children, numberOfLines = 4 }) => {
    const [isClamped, setIsClamped] = useState(true);
    const [showButton, setShowButton] = useState(true);
    const containerRef = useRef();

    const clampClass = `clamp-${numberOfLines}`;

    const checkButtonAvailability = useDebouncedCallback(() => {
        // console.log('check');
        if (!containerRef.current) return;
        // Save current state to reapply later if necessary.
        const hadClampClass = containerRef.current.classList.contains(clampClass);
        // Make sure that CSS clamping is applied if aplicable.
        if (!hadClampClass) containerRef.current.classList.add(clampClass);
        // Check for clamping and show or hide button accordingly.
        setShowButton(hasClamping(containerRef.current));
        // Sync clamping with local state.
        if (!hadClampClass) containerRef.current.classList.remove(clampClass);
    }, 50);
    console.log({ isClamped, showButton });

    useEffect(() => {
        checkButtonAvailability();
        window.addEventListener('resize', checkButtonAvailability);

        return () => {
            window.removeEventListener('resize', checkButtonAvailability);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <>
                <div ref={containerRef} className={classnames(isClamped && clampClass)}>
                    {children}
                </div>
                {showButton && (
                    <ButtonStyled type="button" onClick={() => setIsClamped(!isClamped)}>
                        <span>{isClamped ? 'Read More' : 'Read Less'}</span>
                        <span
                            style={{
                                marginTop: isClamped ? '5px' : 0,
                                transform: `rotate(${isClamped ? '0deg' : '180deg'})`,
                            }}
                        >
                            <CaretIcon fill={colors.azure} />
                        </span>
                    </ButtonStyled>
                )}
            </>
        </>
    );
};

ReadMore.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
    numberOfLines: PropTypes.number,
};

export default ReadMore;
